var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExtContents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.3337C2.01389 12.3337 1.60069 12.1635 1.26042 11.8232C0.920139 11.483 0.75 11.0698 0.75 10.5837V8.83366H2.5V0.666992H11.25V10.5837C11.25 11.0698 11.0799 11.483 10.7396 11.8232C10.3993 12.1635 9.98611 12.3337 9.5 12.3337H2.5ZM9.5 11.167C9.66528 11.167 9.80382 11.1111 9.91562 10.9993C10.0274 10.8875 10.0833 10.7489 10.0833 10.5837V1.83366H3.66667V8.83366H8.91667V10.5837C8.91667 10.7489 8.97257 10.8875 9.08438 10.9993C9.19618 11.1111 9.33472 11.167 9.5 11.167ZM4.25 4.75033V3.58366H9.5V4.75033H4.25ZM4.25 6.50033V5.33366H9.5V6.50033H4.25Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExtContents);
export default __webpack_public_path__ + "static/media/icon_ext_contents.42b80b6272558060ef07b240350302c3.svg";
export { ForwardRef as ReactComponent };